//
// HANDLE COOKIE
//

$('.cookie-bar .cookie-accept').on('click', function () {

    var d = new Date();
    d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = "cookieAgreement=1;" + expires + ";path=/";

    $('.cookie-bar').addClass('hidden');
});

$('.modal-trigger').on('click', function () {
    var target = $(this).data('target-modal');

    $('body').addClass('fixed');

    $('.modal[data-modal="' + target + '"]').removeClass('hide').one(transitionEvent, function () {
        $('.modal[data-modal="' + target + '"]').find('.modal-wrap').removeClass('hide');
    })
});

$('.home-selection .selection a').on('click', function (e) {
    var stage = $(this).data('stage');

    e.preventDefault();

    var d = new Date();
    d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = "stage=" + stage + ";" + expires + ";path=/";

    document.location.href = e.currentTarget.href;
});

var count = 0;
$(document).mouseleave(function () {
    if (count === 0) {
        $('.modal-leave').removeClass('hide');
        $('.modal-leave').find('.modal-wrap').removeClass('hide');
        count++;
        document.cookie = 'leaveModal=1;path=/';
    }
});

//
//AUTO SCROLL
//

function scrollTo(selector, time, offset) {
    $('html, body').animate({
        scrollTop: $(selector).offset().top - offset
    }, time);
}

$('.scroll-down').on('click', function () {
    scrollTo($(this).closest('section').next('section'), 800, 80);
});

$('.to-contacts').on('click', function () {
    if ($(window).width() < 1400) {
        scrollTo('.section-contacts .form-container h2', 800, 90);
    } else {
        scrollTo('.section-contacts .form-container', 800, 80);
    }
});

//
// FLATS FILTERING
//

if ($('.table-body-mobile').length > 0) {
    $('.table-header-mobile').on('click', function () {
        var thisClicker = $(this);
        var thisTableBody = thisClicker.parents('.mobile-room-card').find('.table-body-holder-mobile');
        if (thisClicker.hasClass('active')) {
            thisClicker.removeClass('active');
            thisTableBody.slideUp(300, function () {
                thisTableBody.removeClass('open')
            });
        } else {
            thisClicker.addClass('active');
            thisTableBody.slideDown(300);
        }
    });
}

$('.table-filter li, .table-filter .checkbox').on('click', function () {
    var rows = $('.flats-section .table-body .table-row');
    var mob_rows = $('.flats-section .table-body-mobile .table-row');

    var filterRooms = $(this).attr('data-rooms');
    var filterStage = $(this).attr('data-stage');
    var filterStatus = $(this).attr('data-status');

    // Filter active states
    $(this).siblings().removeClass('active');

    if ($(this).hasClass('active')) {
        $(this).removeClass('active');

        if (filterRooms) {
            rows.removeClass('hidden-rooms');
        } else if (filterStage) {
            rows.removeClass('hidden-stage');
            mob_rows.removeClass('hidden-stage');
        } else if (filterStatus) {
            rows.removeClass('hidden-status');
            mob_rows.removeClass('hidden-status');
        }

    } else {
        $(this).addClass('active');

        if (filterRooms) {
            rows.addClass('hidden-rooms');
            $('.flats-section .table-body .table-content .table-row[data-rooms="' + filterRooms + '"]').removeClass('hidden-rooms');
        } else if (filterStage) {
            rows.addClass('hidden-stage');
            $('.flats-section .table-body .table-content .table-row[data-stage="' + filterStage + '"]').removeClass('hidden-stage');
            mob_rows.addClass('hidden-stage');
            $('.flats-section .table-body-mobile .table-row[data-stage="' + filterStage + '"]').removeClass('hidden-stage');
        } else if (filterStatus) {
            rows.addClass('hidden-status');
            $('.flats-section .table-body .table-content .table-row[data-status="' + filterStatus + '"]').removeClass('hidden-status');
            mob_rows.addClass('hidden-status');
            $('.flats-section .table-body-mobile .table-row[data-status="' + filterStatus + '"]').removeClass('hidden-status');
        }
    }

    $('.table-content').animate({
        scrollTop: 0
    }, 400);

    if (rows.not('.hidden-stage, .hidden-rooms, .hidden-status').length > 7) {
        setTimeout(function () {
            rows.closest('.table-container').addClass('shadow').removeClass('shadow-hidden');
        }, 400);
    } else {
        rows.closest('.table-container').removeClass('shadow');
    }


    if ($(this).hasClass('active') && (parseInt(filterStage) === 1)) {
        $('.table-header-mobile').each(function () {
            $(this).find('.thm-available').text($(this).attr('data-mb-stage-one') + ' laisvi butai');
        });
    } else if ($(this).hasClass('active') && (parseInt(filterStage) === 2)) {
        $('.table-header-mobile').each(function () {
            $(this).find('.thm-available').text($(this).attr('data-mb-stage-two') + ' laisvi butai');
        });
    } else if ($(this).hasClass('active') && (parseInt(filterStage) === 3)) {
        $('.table-header-mobile').each(function () {
            $(this).find('.thm-available').text($(this).attr('data-mb-stage-three') + ' laisvi butai');
        });
    } else {
        $('.table-header-mobile').each(function () {
            $(this).find('.thm-available').text($(this).attr('data-mb-stage-all') + ' laisvi butai');
        });
    }


});

$('.table-header .area').on('click', function () {
    var rows = $('.flats-section .table-body .table-row');

    if ($(this).hasClass('asc')) {
        rows.sort(function (a, b) {
            return $(a).attr("data-area") - $(b).attr("data-area");
        });

        $(this).removeClass('asc');
        $(this).addClass('desc');

    } else if ($(this).hasClass('desc')) {
        rows.sort(function (a, b) {
            return $(b).attr("data-area") - $(a).attr("data-area");
        });

        $(this).removeClass('desc');
        $(this).addClass('asc');
    }

    $('.table-content').html(rows);
});


$('.table-header .price').on('click', function () {
    var rows = $('.flats-section .table-body .table-row');
    if ($(this).hasClass('asc')) {
        rows.sort(function (a, b) {
            return $(a).attr("data-price").replace(/\D/g, '') - $(b).attr("data-price").replace(/\D/g, '');
        });

        $(this).removeClass('asc');
        $(this).addClass('desc');

    } else if ($(this).hasClass('desc')) {
        rows.sort(function (a, b) {
            return $(b).attr("data-price").replace(/\D/g, '') - $(a).attr("data-price").replace(/\D/g, '');

        });

        $(this).removeClass('desc');
        $(this).addClass('asc');
    }
    $('.table-content').html(rows);
});
//
// FLOORS FILTERING
//

function updateFloorSelectionUrl() {
    var splitURL = window.location.href.split('/');
    // console.log(splitURL);

    var paramIndex;
    if (splitURL.indexOf('aukstai') > -1) {
        paramIndex = splitURL.indexOf('aukstai');
    } else if (splitURL.indexOf('aukstai-ii') > -1) {
        paramIndex = splitURL.indexOf('aukstai-ii');
    } else if (splitURL.indexOf('aukstai-iii')) {
        paramIndex = splitURL.indexOf('aukstai-iii');
    }  else {
        paramIndex = splitURL.indexOf('rinktis-buta');
    }

    splitURL[paramIndex + 1] = selectedBuilding;
    splitURL[paramIndex + 2] = selectedFloor;

    if (history.replaceState) {
        window.history.replaceState(null, null, splitURL.join('/'));
    }
}

function getFloorFromUrl() {
    var splitURL = window.location.href.split('/');
    if (splitURL.indexOf('aukstai')) {
        var paramIndex = splitURL.indexOf('aukstai');
    } else if (splitURL.indexOf('aukstai-ii')) {
        var paramIndex = splitURL.indexOf('aukstai-ii');
    } else if (splitURL.indexOf('aukstai-iii')) {
        var paramIndex = splitURL.indexOf('aukstai-iii');
    } else {
        var paramIndex = splitURL.indexOf('rinktis-buta');
    }


    return splitURL[paramIndex + 2]
}

// Building selection
$('.floor-flats .building-selection .item').on('click', function () {

    if (!$(this).hasClass('prevent')) {
        var prevActive = 1;
        if ($('.building-swiper.active .building-block.active').length > 0) {
            prevActive = $('.building-swiper.active .building-block.active').attr('data-floor-target');
        } else if ($('.building-swiper.active .building-block.open').length > 0) {
            prevActive = $('.building-swiper.active .building-block.open').attr('data-floor-target');
        }

        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        var path = $(this).closest('.buildings-map').find('svg path');

        selectedBuilding = $(this).data('building-target');
        selectedFloor = $('.building-swiper#k' + selectedBuilding).find('.plan-link.active').data('floor-target');

        path.each(function () {
            if ($(this).attr('data-building-target') != selectedBuilding) {
                $(this).removeClass('active');
            } else {
                $(this).addClass('active');
            }
        });

        if (!selectedFloor) {
            console.log('no selected floor');
            selectedFloor = 1;

            $('.building-swiper#k' + selectedBuilding + ' .plan-link[data-floor-target=1]').addClass('active');
        }

        $('.building-swiper').removeClass('active');
        $('.building-swiper#k' + selectedBuilding).addClass('active');

        $('.building-swiper#k' + selectedBuilding + ' .building-block').removeClass('active');
        $('.building-swiper#k' + selectedBuilding + ' .building-block').removeClass('open');
        $('.building-swiper#k' + selectedBuilding + ' .building-block[data-floor-target=' + prevActive + ']').addClass('active');

        updateFloorSelectionUrl();
    }
});

//
// BIG GALLERY SHOWCASE
//

$('.big-gallery .open-gallery').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.big-gallery').addClass('gallery-active');
});

$('.galleries .open-gallery').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('gallery-active-first');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .open-gallery-second').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('gallery-active-second');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .open-gallery-third').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('gallery-active-third');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .open-construction-progress').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('progress-content-active');
    $('body').addClass('light');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .open-construction-progress-second').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('second-progress-content-active');
    $('body').addClass('light');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .open-construction-progress-third').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').addClass('third-progress-content-active');
    $('body').addClass('light');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".galleries").offset().top
    }, 1000);
});

$('.galleries .progress-link-to-gallery').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('progress-content-active');
    $(this).closest('.galleries').addClass('gallery-active-first');
    $('body').removeClass('light');
});

$('.galleries .progress-link-to-gallery-second').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('second-progress-content-active');
    $(this).closest('.galleries').addClass('gallery-active-second');
    $('body').removeClass('light');
});

$('.galleries .progress-link-to-gallery-third').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('third-progress-content-active');
    $(this).closest('.galleries').addClass('gallery-active-third');
    $('body').removeClass('light');
});

$('.galleries .gallery-link-to-progress-first').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('gallery-active-first');
    $(this).closest('.galleries').addClass('progress-content-active');
    $('body').addClass('light');
});

$('.galleries .gallery-link-to-progress-second').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('gallery-active-second');
    $(this).closest('.galleries').addClass('second-progress-content-active');
    $('body').addClass('light');
});

$('.galleries .gallery-link-to-progress-third').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.galleries').removeClass('gallery-active-third');
    $(this).closest('.galleries').addClass('third-progress-content-active');
    $('body').addClass('light');
});

//
// SPECIAL OFFER
//
$('.special-offer, .call-offer').on('click', function () {
    if(!$(this).hasClass('link')) {
        if($('.modal.special-offers:not([data-modal])').length > 0) {
            $('body').addClass('fixed');

            $('.modal.special-offers:not([data-modal])').removeClass('hide').one(transitionEvent, function () {
                $('.modal.special-offers:not([data-modal])').find('.modal-wrap').removeClass('hide');
            })
        }
    }
});

//
// BANK OFFERS MODAL
//
$('.bank-offers-trigger').on('click', function (e) {
    e.preventDefault();

    $('body').addClass('fixed');

    $('.modal.bank-offers').removeClass('hide').one(transitionEvent, function () {
        $('.modal.bank-offers').find('.modal-wrap').removeClass('hide');
    })
});

//
// CONTACTS FORM SUBMIT
//

$('.wpcf7 .submit-btn .arrow-link').on('click', function () {
    $(this).closest('form').find('.submit-wpcf input')[0].click();
});

//
// MOBILE MENU
//

$('.menu-toggle').on('click', function () {
    $(this).find('.burger').toggleClass('active');
    $(this).parent().find('.menu-mobile').toggleClass('active');
});

$(document).on('click', '.filter a', function (e) {
    var href = $(this).attr('href').split('#');
    var window_href = window.location.href.split('#');
    if (href[0] === window_href[0]) {
        if ($('.menu-mobile').hasClass('active')) {
            $('.menu-mobile').removeClass('active');
            $('.burger').removeClass('active');
        }
    }

});

//
// SUCCESS ID FOR FORMS
//
if(document.querySelector('.modal .wpcf7')) {
    var popupForm = document.querySelector('.modal .wpcf7'),
        contactForm = document.querySelector('.section-contacts .wpcf7');

    if ($('.section-contacts .wpcf7').length) {
        contactForm.addEventListener('wpcf7mailsent', function (event) {
            $(contactForm).find('.success-message').addClass('active');
        }, false);
    }

    popupForm.addEventListener('wpcf7mailsent', function (event) {
        $(popupForm).find('.success-message').addClass('active');
    }, false);
}


$(".table-content").on("scroll", function (e) {
    horizontal = e.currentTarget.scrollLeft;
    vertical = e.currentTarget.scrollTop;
    // console.log($(window).width() < 768);
    // console.log(horizontal > 0);
    if (($(window).width() < 768) && (horizontal > 0)) {
        $('.table-content-mobileIndicator').remove();
    }


    // console.log(horizontal);
    // console.log(vertical);

});